import { scaleLinear } from "@visx/scale";

export const smoothAtKinks =
  (startPitches: number[], anchorBleed: number) =>
  (pitches: number[], ix: number) => {
    // Create a copy of the pitches array to avoid modifying the original
    const smoothedPitches = [...pitches];

    // Find the farthest non-zero point back from ix within anchorBleed
    let backPoint = null;
    for (let i = ix - 1; i >= Math.max(0, ix - anchorBleed); i--) {
      if (pitches[i] !== 0) {
        backPoint = i;
      } else {
        break;
      }
    }

    // Find the farthest non-zero point forward from ix within anchorBleed
    let forwardPoint = null;
    for (
      let i = ix + 1;
      i <= Math.min(pitches.length - 1, ix + anchorBleed);
      i++
    ) {
      if (pitches[i] !== 0) {
        forwardPoint = i;
      } else {
        break;
      }
    }

    // If either backPoint or forwardPoint is null, we cannot perform interpolation
    if (backPoint === null || forwardPoint === null) {
      return smoothedPitches;
    }

    const backValue = pitches[backPoint];
    const forwardValue = pitches[forwardPoint];
    const origBackValue = startPitches[backPoint];
    const origForwardValue = startPitches[forwardPoint];
    const scaleForPitchSimple = scaleLinear({
      domain: [backPoint, forwardPoint],
      range: [backValue, forwardValue],
    });
    const oldScaleForPitchSimple = scaleLinear({
      domain: [backPoint, forwardPoint],
      range: [origBackValue, origForwardValue],
    });

    // Perform linear interpolation between backPoint and forwardPoint
    for (let i = backPoint; i < forwardPoint; i++) {
      const origDiff = startPitches[i] - oldScaleForPitchSimple(i);
      const placeOnLine = scaleForPitchSimple(i) + origDiff;
      smoothedPitches[i] = placeOnLine;
    }

    return smoothedPitches;
  };
